
export default function StudentAdress() {
    return (
        <>
            <div className='marginPlus'>
                Aderss place
            </div>
        </>
    )
}
